import { RadioGroup, List, Radio, ListItem, ListItemIcon, ListItemAvatar, Avatar, ListItemText, Button, Divider, useTheme } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { Call02Icon } from "@hugeicons/core-free-icons";
import { AnonymousUser, User } from "@/types";
import { stringToColor, getInitials } from "@/utils/names";
import { formatPhone } from "@/utils/phones";

interface Props {
  results: Partial<AnonymousUser | User>[];
  selectedId: string | null;
  onSelect: (id: string, user: any) => void;
  onOpenCustomer: (id: string) => void;
}

const CustomerList = ({ results, selectedId, onSelect, onOpenCustomer }: Props) => {
  const { palette } = useTheme();

  return (
    <RadioGroup
      value={selectedId}
      onChange={(e) => {
        const id = e.target.value;
        const user = results.find((x) => x.id === id);
        if (user) onSelect(id, user);
      }}
    >
      <List disablePadding>
        {results.map((c) => (
          <div key={c?.id}>
            <ListItem>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <Radio value={c?.id} edge="start" />
              </ListItemIcon>

              <ListItemAvatar>
                <Avatar
                  sx={{
                    fontSize: 16,
                    backgroundColor: stringToColor(`${c?.name} ${c?.lastname}`),
                  }}
                >
                  {getInitials(`${c?.name ?? ""} ${c?.lastname ?? ""}`)}
                </Avatar>
              </ListItemAvatar>

              <ListItemText
                primary={`${c?.name} ${c?.lastname}`}
                secondary={
                  <span>
                    <HugeiconsIcon icon={Call02Icon} style={{ verticalAlign: "middle", marginRight: 4 }} color={palette.primary.main} />
                    {formatPhone(c.phone)}
                  </span>
                }
              />

              <Button
                variant="contained"
                size="small"
                onClick={() => {
                  onOpenCustomer(c?.id);
                }}
              >
                Ver
              </Button>
            </ListItem>
            {results.length > 1 ? <Divider /> : null}
          </div>
        ))}
      </List>
    </RadioGroup>
  );
};
export default CustomerList;
